import { render, staticRenderFns } from "./SideDialogCloseWork.vue?vue&type=template&id=7f53ded4&scoped=true&"
import script from "./SideDialogCloseWork.vue?vue&type=script&lang=js&"
export * from "./SideDialogCloseWork.vue?vue&type=script&lang=js&"
import style0 from "./SideDialogCloseWork.vue?vue&type=style&index=0&id=7f53ded4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f53ded4",
  null
  
)

component.options.__file = "SideDialogCloseWork.vue"
export default component.exports